export default () => ({
    count: null,
    isLoading: false
})
